import React from 'react';
import { NavLink } from 'react-router-dom';

import classes from './NavigationItem.module.css';

const navigationItem = ( props ) => (
    <li className={classes.NavigationItem} onClick={props.sideDrawerClosed}>
        <NavLink
            to={props.link}
            exact={props.exact}
            activeClassName={classes.active}
            onClick={(event) => {
                if (props.doInstead) {
                    event.preventDefault();
                    props.doInstead();
            }}}>{props.children}
        </NavLink>
    </li>
);

export default navigationItem;